//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'APGAR',
  data() {
    return {
      form:{
        skin:'',
        heart:'',
        reflex:'',
        muscle:'',
        breathing:''
      },
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:"0",name:'青紫或苍白'},
        {value:"1",name:'躯干红，四肢青紫'},
        {value:"2",name:'全身红'}
      ],
      dataList2:[
        {value:"0",name:'无'},
        {value:"1",name:'< 100'},
        {value:"2",name:'> 100'}
      ],
      dataList3:[
        {value:"0",name:'无'},
        {value:"1",name:'有皱眉等表情'},
        {value:"2",name:'咳嗽、喷嚏或哭'}
      ],
      dataList4:[
        {value:"0",name:'松弛'},
        {value:"1",name:'四肢稍屈曲'},
        {value:"2",name:'四肢活动可'}
      ],
      dataList5:[
        {value:"0",name:'无'},
        {value:"1",name:'浅、慢、不规则，哭声弱'},
        {value:"2",name:'正常，哭声响亮'}
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        let result = form.skin + form.heart + form.reflex + form.muscle + form.breathing
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ObGyn/APGAR.vue